import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'
import { PerkItemProps } from '../PerkTypes'

export const PerkItem = dynamic(
  import('./PerkItem')
    .then((mod) => mod.PerkItem)
    .catch((err) =>
      logger().error('Failed to load dynamic component', { component: 'PerkItem' }, err),
    ) as DynamicOptions<PerkItemProps>,
  {
    ssr: false,
  },
)
